export default __webpack_public_path__ + "static/media/slider-unraf-3.b91985ee.jpg";